import styled from "styled-components";

export const ContainerMapFixedPointCoord = styled.div`

`;
